module.exports = __webpack_public_path__ + "img/icons-4.20a2b3db.png";